/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Grey placeholder rows shown while a 2026-design list loads (DESIGN_SYSTEM.html, Loading).
// Hidden from screen readers; the list's own aria-busy and loading text carry the state.
@Component({
  selector: 'ut-skeleton-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (announce) {
      <span class="sr-only" role="status">Loading</span>
    }
    <div class="skeleton-list" [class.skeleton-list--people]="variant === 'people'" aria-hidden="true">
      @for (row of rows; track row) {
        <div class="skeleton-list__item">
          <span class="skeleton skeleton--avatar"></span>
          <span class="skeleton-list__lines">
            <span class="skeleton skeleton--title"></span>
            <span class="skeleton"></span>
            @if (variant === 'card') {
              <span class="skeleton skeleton--short"></span>
            }
          </span>
        </div>
      }
    </div>
  `,
  styleUrls: ['./skeleton-list.component.scss'],
})
export class SkeletonListComponent {
  // 'card' matches feed and activity cards; 'people' matches the Followers / Following grid.
  @Input() variant: 'card' | 'people' = 'card';

  // false when the page already has a status region saying it is loading.
  @Input() announce = true;

  rows: number[] = [0, 1, 2];

  @Input() set count(count: number) {
    this.rows = Array.from({ length: count }, (_, i) => i);
  }
}
